/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentTemplateType {
    CUSTOM = 'CUSTOM',
    NOTICE = 'NOTICE',
    NOTICE_REQUIRING_ACKNOWLEDGMENT = 'NOTICE_REQUIRING_ACKNOWLEDGMENT',
    AGREEMENT = 'AGREEMENT',
    AGREEMENT_ADVANCED_SIGNATURE = 'AGREEMENT_ADVANCED_SIGNATURE',
    SCHEDULE = 'SCHEDULE',
    FORM = 'FORM',
    UK_DEED = 'UK_DEED',
    POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
    SIDE_LETTER = 'SIDE_LETTER',
    ANNUAL_REPORT = 'ANNUAL_REPORT',
    VALUATION = 'VALUATION',
    RESOLUTION = 'RESOLUTION',
    PRE_FILLABLE_FORM = 'PRE_FILLABLE_FORM',
    GDPR_NOTICE = 'GDPR_NOTICE',
    FORM_S431 = 'FORM_S431',
}
